import { render, staticRenderFns } from "./EnterpriseDetails.vue?vue&type=template&id=0885f22a&"
import script from "./EnterpriseDetails.vue?vue&type=script&lang=js&"
export * from "./EnterpriseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports